import { render } from "./AddRecurringTermComponent.vue?vue&type=template&id=562d54ef"
import script from "./AddRecurringTermComponent.vue?vue&type=script&lang=js"
export * from "./AddRecurringTermComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__